module.exports = __webpack_public_path__ + "static/media/Army-Green_2.b72a95ff.jpg";